export const projects = [
    {
      id: 1,
      name: 'TrashMe',
      tag: ['Non-recyclable'],
      image: 'https://images.fineartamerica.com/images-medium-large-5/coffee-cup-isolated-studiocasper.jpg',
      components: ''
    },
    {
      id: 2,
      name: 'Sride',
      tag: ['Liquid', 'Plastic', 'Paper', 'Non-recyclable'],
      image: 'https://images.fineartamerica.com/images-medium-large-5/coffee-cup-isolated-studiocasper.jpg'
    },
    {
        id: 3,
        name: 'ValetBike',
        tag: ['Liquid', 'Plastic', 'Paper', 'Non-recyclable'],
        image: 'https://images.fineartamerica.com/images-medium-large-5/coffee-cup-isolated-studiocasper.jpg'
      }
  ];